import { StarGlyph } from "./Reveal";

const ITEMS = [
  "HANDMADE ORIGINAL",
  "FOR THE SUN AND BEYOND",
  "MARSTAR ORIGINALS",
  "CLOTHING · BAGS · JEWELRY · CUSTOMS",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee" className="overflow-hidden border-y border-ink/10 bg-cream py-5">
      <div className="marquee-track flex w-max items-center">
        {[0, 1, 2].map((dup) => (
          <div key={dup} className="flex items-center" aria-hidden={dup > 0}>
            {row.map((t, i) => (
              <span
                key={`${dup}-${i}`}
                className="flex items-center gap-10 pr-10 font-mono text-xs tracking-[0.4em] text-ink/70"
              >
                {t}
                <StarGlyph className="h-3 w-3" fill={i % 2 ? "#FF8A3D" : "#FF2E9E"} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
